(ns frontend.view.components.oppos-per-users-chart)

(defn series-data
  [items color]
  (let [data (map :count items)
        head (first data)
        tail (rest data)]
    (conj
     (map (fn [v] {:y v :color "gray"}) tail)
     {:y head :color color})))

(defn background-series-data
  [items]
  (let [m (* 1.15
             (-> items
                 first
                 :count))]
    (map (fn [{:keys [count]}] {:y (- m count) :color "lightgray"}) items)))

(defn options
  [{:keys [largest-bar-color height]} items]
  {:chart       {:type   "bar"
                 :height height}
   :title       {:text nil}
   :xAxis       [{:categories      (map :label items)
                  :lineWidth       0
                  :labels          {:x     0
                                    :y     -10
                                    :align "left"}
                  :minorTickLength 0
                  :tickLength      0}
                 {:categories      (map :count items)
                  :lineWidth       0
                  :labels          {:x       -10
                                    :y       -10
                                    :align   "right"
                                    :useHTML false
                                    :style   {:fontWeight "bold"}}
                  :minorTickLength 0
                  :tickLength      0
                  :linkedTo        0
                  :opposite        true}]
   :yAxis       {:visible    false
                 :maxPadding 0}
   :series      [{:data       (background-series-data items)
                  :animation  false
                  :pointWidth 7}
                 {:data       (series-data items largest-bar-color)
                  :animation  false
                  :pointWidth 7}]
   :plotOptions {:series {:stacking    "normal"
                          :borderWidth 0}}
   :tooltip     {:enabled false}
   :credits     {:enabled false}
   :legend      {:enabled false}})
